import { ContainerModule, interfaces } from 'inversify';
import { AnnotationTypeBl, IAnnotationTypeBl } from './annotationType.bl';
import { AnnotationTypeStore, IAnnotationTypeStore } from './annotationType.store';
import { GetAnnotationTypesService, IGetAnnotationTypesService } from './services/getAnnotationTypesService';

export const annotationTypeModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(IGetAnnotationTypesService.$).to(GetAnnotationTypesService).inSingletonScope();
  bind(IAnnotationTypeBl.$).to(AnnotationTypeBl).inSingletonScope();
  bind(IAnnotationTypeStore.$).to(AnnotationTypeStore).inSingletonScope();
});
